var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC98(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.06 10.781c0-3.198-2.63-5.78-5.888-5.78-3.257 0-5.888 2.582-5.764 5.78 0 .984.189 1.907.69 2.768.689-.614 1.566-1.046 2.443-1.353a2.813 2.813 0 0 1-.375-1.414c0-1.66 1.378-3.012 3.07-3.012 1.69 0 3.07 1.352 3.07 3.013 0 .493-.127.984-.377 1.415.877.307 1.691.8 2.442 1.353.44-.861.69-1.784.69-2.767zM2.94 20.807c0 3.198 2.63 5.78 5.887 5.78 3.258 0 5.889-2.582 5.889-5.78h-2.819c0 1.66-1.378 3.013-3.07 3.013-1.69 0-3.069-1.354-3.069-3.014H2.94zM2 11.764c0 3.69 3.07 6.704 6.827 6.704 3.76 0 6.829-3.013 6.891-6.704 0-3.75-3.132-6.764-6.89-6.764S2 8.075 2 11.764zm14.282 8.118c0 3.69 3.132 6.704 6.89 6.704v.001c3.758 0 6.828-3.014 6.828-6.704 0-3.751-3.07-6.765-6.828-6.765-3.82 0-6.89 3.014-6.89 6.764zm6.89 3.875c2.255 0 4.07-1.721 4.07-3.935 0-2.154-1.815-3.936-4.07-3.999-2.255 0-4.072 1.784-4.072 3.999 0 2.152 1.817 3.935 4.072 3.935zM8.765 15.763c2.255 0 4.071-1.784 4.071-3.999v.001c0-2.215-1.753-3.998-4.07-3.998-2.256 0-4.073 1.783-4.073 3.997 0 2.215 1.817 3.999 4.072 3.999z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC98);
export default __webpack_public_path__ + "static/media/C98.83a1927faf16a6996d63f38e2895431b.svg";
export { ForwardRef as ReactComponent };